import { node } from 'prop-types';

import useStyles from './AppStyles';
import useThemeStyles from '../../themes/ThemeStyles';

export default function AppCssBaseline(props) {
    const { children } = props;

    useThemeStyles();

    useStyles();

    return children;
}

AppCssBaseline.propTypes = {
    children: node,
};

AppCssBaseline.defaultProps = {
    children: null,
};
